import { put, call, take, fork } from 'redux-saga/effects'
import { CourseCreationSuggestGoalService } from '../../api/course-creation'
import { aICreatorSuggestGoalSuccess } from '../../reducers/ai-creator/action'
import { SUGGEST_GOAL } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 * Flow for suggesting learning goals
 * @param {Object} payload - The payload containing requestData and callback
 */
function* suggestGoalFlow(payload) {
  try {
    const { requestData, callback } = payload

    const response = yield call(CourseCreationSuggestGoalService, requestData)

    yield put(aICreatorSuggestGoalSuccess(response))
    yield put(operationSuccess())

    if (callback) {
      callback(response)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 * Watcher for suggest goal actions
 */
export default function* aICreatorSuggestGoalWatcher() {
  while (true) {
    const action = yield take(SUGGEST_GOAL)
    const { payload } = action

    yield fork(generalSaga, suggestGoalFlow, payload, false)
  }
}
